<template>
    <v-dialog v-model="dialog.abrir" width="500" scrollable persistent>
        <v-card class="co-dialog-novo-modelo">
            <span class="wapper-titulo-close px-5">
                <v-card-title class="titulo px-0">
                    <span>{{ dialog.editando ? 'Renomear Modelo' : 'Novo Modelo' }}</span>
                </v-card-title>
                <v-icon class="icon-close" size="21" @click="fechar"> mdi-window-close </v-icon>
            </span>

            <form class="px-5" @submit.prevent="realizarAcao" data-vv-scope="form-novo-modelo">
                <v-card-text class="campos d-flex px-0 pt-0">
                    <div>
                        <v-text-field
                            class="required-field"
                            label="Título"
                            placeholder="Informe o título"
                            name="título"
                            v-validate="'required|max:255'"
                            v-model="modelo.tituloModelo"
                            :error-messages="errors.collect('título', 'form-novo-modelo')"
                            autofocus
                        />
                    </div>
                    <div>
                        <span class="label-situacao">
                            Situação
                        </span>

                        <div class="d-flex">
                            <v-radio-group
                                row
                                name="situacao-modelo"
                                v-model="modelo.situacao"
                                v-for="situacao in situacoes"
                                :key="situacao"
                                hide-details
                            >
                                <v-radio
                                    name="situacao"
                                    class="mb-0 text-capitalize"
                                    color="primary"
                                    :label="situacao.toLowerCase()"
                                    :value="situacao"
                                />
                            </v-radio-group>
                        </div>
                    </div>
                </v-card-text>

                <v-card-actions class="acoes justify-space-between pb-4 px-0">
                    <div class="btn-cancelar">
                        <v-btn depressed @click="fechar">Cancelar</v-btn>
                    </div>

                    <div class="btn-criar">
                        <v-btn color="primary" depressed :loading="loading" type="submit">Salvar</v-btn>
                    </div>
                </v-card-actions>
            </form>
        </v-card>
    </v-dialog>
</template>

<script>
import {actionTypes} from '@/commons/constants'

export default {
    name: 'DialogNovoModelo',
    props: {
        dialog: {
            type: Object
        },
        modelo: {
            type: Object
        }
    },
    computed: {
        ehMobile() {
            return this.$vuetify.breakpoint.xsOnly
        }
    },
    data() {
        return {
            situacoes: ['ATIVO', 'INATIVO'],
            loading: false
        }
    },
    methods: {
        async atualizarModelo() {
            try {
                await this.$store.dispatch(actionTypes.MODELO.EDITAR, {
                    id: this.modelo.id,
                    body: {
                        titulo: this.modelo.tituloModelo,
                        situacao: this.modelo.situacao
                    }
                })

                this.mostrarNotificacaoSucessoDefault()
                this.$emit('buscar-modelos')
                this.fechar()
            } catch {
                this.loading = false
            }
        },
        async criarModelo() {
            try {
                const modelo = await this.$store.dispatch(actionTypes.MODELO.CRIAR, {
                    titulo: this.modelo.tituloModelo,
                    situacao: this.modelo.situacao
                })

                this.mostrarNotificacaoSucessoDefault()
                this.$router.push({name: 'visualizarModelo', params: {id: modelo.modeloId, tipo:'edicao'}})
                this.fechar()
            } catch {
                this.loading = false
            }
        },
        fechar() {
            this.modelo.tituloModelo = ''
            this.modelo.situacao = 'ATIVO'
            this.$emit('fechar')
        },
        async realizarAcao() {
            const modeloValido = await this.$validator._base.validateAll('form-novo-modelo')

            if (!modeloValido) {
                return
            }

            this.loading = true

            if (this.dialog.editando) {
                await this.atualizarModelo()
            } else {
                await this.criarModelo()
            }

            this.loading = false
        },
    }
}
</script>

<style lang="stylus" scoped>
.co-dialog-novo-modelo
    .wapper-titulo-close
        display flex
        align-items center
        justify-content space-between

    .titulo
        color var(--primary)
        width 100%

    .campos
        gap 10px
        flex-direction column

        .label-situacao
            font-size 16px
            font-weight 400
            color #777777

@media (max-width: 500px)
    .co-dialog-novo-modelo
        .wapper-titulo-close
            .icon-close
                font-size 15px !important

        .titulo
            color var(--primary)
            font-size 16px

        .acoes
            flex-direction column
            gap 14px

            .btn-cancelar,
            .btn-criar
                width 100%

                button
                    width 100%


</style>
